import './App.css';
import NeuroWiseScreening from './NeuroWiseScreening';

function App() {
  return (
    <div className="App">
      <NeuroWiseScreening />
    </div>
  );
}

export default App;